import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { SIDE_NAV_WIDTH, TOP_NAV_HEIGHT } from 'src/constants';

export const StandardLayoutWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const Content = styled(Box)`
  flex: 1;
  margin-left: ${SIDE_NAV_WIDTH}px;
  min-width: 0;
  height: 100%;
`;

export const ContentInner = styled(Box)`
  height: 100%;
  padding: 20px 30px;
  width: 100%;
  overflow: auto;
`;

export const OwnerOperatorContent = styled(Box, {
  shouldForwardProp: (prop: any) =>
    prop !== '$withTopBar' && prop !== '$fullScreen',
})<{ $withTopBar?: boolean; $fullScreen?: boolean }>(
  ({ $withTopBar = true, $fullScreen = false }) => ({
    marginLeft: $fullScreen ? 0 : SIDE_NAV_WIDTH,
    marginTop: $withTopBar ? TOP_NAV_HEIGHT : 0,
    minHeight: $withTopBar ? `calc(100vh - ${TOP_NAV_HEIGHT}px)` : '100vh',
    background: 'rgba(249, 249, 252, 1)',
  }),
);

export const OwnerOperatorContentInner = styled(Box, {
  shouldForwardProp: (prop: any) => prop !== '$fullScreen',
})<{ $fullScreen?: boolean }>(({ $fullScreen = false }) => ({
  padding: $fullScreen ? 0 : '0 20px',
}));
